import * as React from 'react';
import { observer } from 'mobx-react';

import { SubmitButton } from '../../components/submit-button/submit-button';
import { FrequencyCode, PaymentLabel } from '../../webgiving-generated';
import { Text} from '../text';

export const GiveButton = observer(({
		frequency,
		amountFormatted,
		paymentLabel,
		isLoading,
		acceptanceTestTargetId,
		isBlocked,
	}: {
		frequency: FrequencyCode | null,
		amountFormatted: string,
		currencyCode?: string,
		paymentLabel: PaymentLabel,
		isLoading: boolean,
		acceptanceTestTargetId: string,
		isBlocked?: boolean,
	}) => {
	const giveButtonText = frequency ? (<Text>Schedule recurring {paymentLabel.NounLowerCase}</Text>) 
		: (<Text params={{ amount: `$${amountFormatted}` }}>{`${paymentLabel.VerbSentenceCase} {{amount}}`}</Text>);
	
	return <SubmitButton acceptanceTestTargetId={acceptanceTestTargetId} isLoading={isLoading} isBlocked={isBlocked}>{giveButtonText}</SubmitButton>;
});
